import styled from 'styled-components'

import { SubArticleShow } from './SubArticle'

export interface SubarticleProps {
  parentsArticle: string[]
  permalink: string
  isInternal: boolean
  className: string
  text: string
  changeView: (searchKey: string, page: string) => void
}

export const SubArticle = styled(SubArticleShow)`
  border: 1px solid rgba(51, 51, 51, 0.24);
  border-radius: 4px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05);
  margin: 15px 0;
  transition: box-shadow 0.3s ease-in-out;
  padding: 0 20px;
  box-sizing: border-box;
  &:hover {
    box-shadow: 0 9px 16px 0 rgba(0, 0, 0, 0.1);
  }
  span.iconContainer {
    display: table-cell;
    vertical-align: middle;
    font-size: 20px;
  }
  span.title {
    cursor: pointer;
    display: table-cell;
    vertical-align: middle;
    margin-bottom: 0;
    font-size: 18px;
    font-weight: 600;
    padding: 15px 0 15px 15px;
    width: calc(100% - 15px);
    box-sizing: border-box;
  }
  .svg-inline--fa {
    transition: transform 400ms ease-out;
  }
  .titleContent {
    border-bottom: 1px solid rgba(51, 51, 51, 0.24);
    cursor: pointer;
    .svg-inline--fa {
      transform: rotate(90deg);
    }
  }
  .articleContent {
    max-width: 100% !important;
    box-sizing: border-box;
  }
  .subArticleContent {
    margin-top: 10px;
  }
`

export const SubarticleContent = styled.div`
  display: inline-block;
  max-width: 616px;
  padding-left: 16px;
  padding-right: 16px;
  margin-top: 10px;
`
